import { createFileRoute } from "@tanstack/react-router";
import { Invites } from "../../features/settings/invites";

export const Route = createFileRoute("/_authed/$org/team/invites")({ component: InvitesPage });

function InvitesPage() {
  return <Invites org={Route.useParams().org} />;
}
